// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"10c891b2","396":"386039c3","453":"6f9b4be7","667":"64e8556d","977":"1ea83add"}[chunkId] + ".chunk.js";
};